module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/scrollbar/scrollbar.component.html
// module id = ../../../../../src/app/core/scrollbar/scrollbar.component.html
// module chunks = main